import { render, staticRenderFns } from "./ChainIcon.vue?vue&type=template&id=fe77a8f4&"
import script from "./ChainIcon.vue?vue&type=script&lang=js&"
export * from "./ChainIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports